module.exports = __webpack_public_path__ + "static/media/avatar.b6681619.png";


//////////////////
// WEBPACK FOOTER
// ./src/avatar.png
// module id = 56
// module chunks = 0